import axios from "axios";

export default {
  async create(formData) {
    const files = new FormData();
    files.append("files", formData.file);

    const data = formData;
    data.file = undefined;
    files.append("data", JSON.stringify(data));

    const config = {
      headers: {
        "content-type": "multipart/form-data"
      }
    };
    return axios.post(`/rent-object-booking-attachments/rent-object-bookings/${formData.rentObjectBookingId}`, files, config);
  },
  async findAll(formData) {
    return axios.get(`/rent-object-booking-attachments/rent-object-bookings/${formData.rentObjectBookingId}`);
  },
  async getAttachement(formData) {
    return axios.get(`/rent-object-booking-attachments/${formData.id}`, { responseType: 'arraybuffer' });
  },
  async delete({ id }) {
    return axios.delete(`/rent-object-booking-attachments/${id}`);
  },
};